import { graphql } from '@tn/foundation/graphql/__generated/gql';

export const bindPartnerDocument = /* GraphQL */ `
    mutation BindPartner($fields: BindPartnerFields!) {
        bindPartner(fields: $fields) {
            success
            errorCode
        }
    }
`;
export const bindPartnerMutation = graphql(bindPartnerDocument);
